import styled from 'styled-components'

import theme from 'style/theme'

export default styled.div`
  .ant-tag {
    border-radius: 20px;
    background: transparent;
    border: 1px solid ${theme.mediumGray};
    padding: 3px 14px;
    color: ${theme.mediumGray};
    margin-right: 0;

    &.small {
      padding: 0 8px;
    }
  }
`
